import Checkbox from '@vtex/styleguide/lib/Checkbox';

const VtexCheckbox = (props) => <Checkbox {...props} />;

export default VtexCheckbox;
